// extracted by mini-css-extract-plugin
var _1 = "GretaAIChatProjectsPage-modulecolumn__nV9N5";
var _2 = "GretaAIChatProjectsPage-modulepage__NuGMk";
export { _1 as "column", _2 as "page" }
